import React, { useEffect } from 'react';
import {
  SortableContainer,
  SortableElement,
  arrayMove,
} from 'react-sortable-hoc';
import OmnichannelLogosDisabled from '@src/components/Icon/omnichannel-logos-disabled.svg';
import ChannelAccordion from '../ChannelAccordion';
import './OmniChannelWidget.scss';

const SortableItem = SortableElement(ChannelAccordion);

const SortableWrapper = SortableContainer(({ children }) => {
  return <ul>{children}</ul>;
});

const OmniChannelWidget = ({ channels, onChange, value }) => {
  const [channelsData, setChannelsData] = React.useState(value);

  const updateChannelsData = (newData) => {
    setChannelsData([...newData]);
    onChange(newData);
  };

  useEffect(() => {
    setChannelsData(value);
  }, [value]);

  const sortHandler = ({ oldIndex, newIndex }) => {
    updateChannelsData(arrayMove(channelsData, oldIndex, newIndex));
  };

  const handleFieldChange = (index, key, value) => {
    channelsData[index][key] = value;
    updateChannelsData(channelsData);
  };

  const activeWidgets =
    channelsData && channelsData.filter((channelData) => channelData.enabled);
  const activeWidgetsLength = activeWidgets.length;

  const width = (32 * activeWidgetsLength) / 1.4;

  const showPreview = (data) =>
    data.map((channelData) => {
      const Icon = channels[channelData.type].icon;
      return (
        <span className="preview-item">
          <Icon />
        </span>
      );
    });

  return (
    <div className="channels-block-language ">
      <div className="channels-block-title">Omnichannel Widgets</div>
      <div className="preview">
        <div className="skeleton-avatar" />
        <div className="skeleton-horizontal-container">
          <div className="skeleton-horizontal" />
          <div className="skeleton-horizontal" />
        </div>
        {activeWidgetsLength > 0 ? (
          <div
            className="preview-item-container"
            style={{ width, marginRight: '18px' }}
          >
            {showPreview(activeWidgets)}
          </div>
        ) : (
          <div className="preview-item-container">
            <OmnichannelLogosDisabled />
          </div>
        )}
      </div>
      <div className="info">
        Configure and showcase direct click-to-chat links to Whatsapp, Facebook,
        Instagram on the SDK.{' '}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://docs.haptik.ai/en_US/how-to-enable-omnichannel-widgets-on-my-web-bot"
        >
          Learn more.
        </a>
      </div>
      <div className="widget-options">
        <SortableWrapper onSortEnd={sortHandler} useDragHandle>
          {channelsData.map((channelData, index) => {
            const channel = channels[channelData.type];
            return (
              <SortableItem
                index={index}
                onChange={handleFieldChange}
                icon={channel.icon}
                label={channel.label}
                data={channelData}
                fields={channel.fields}
                itemIndex={index}
              />
            );
          })}
        </SortableWrapper>
      </div>
    </div>
  );
};

export default OmniChannelWidget;
